import { HelpTip } from './types';

export const INSPECTION_TIPS = {
  inspectionsTable: {
    title: { fr: 'Les inspections', en: 'Inspections' },
    text: {
      fr: "Toutes les inspections de votre périmètre, réalisées par un professionnel ou par un particulier. La liste se met à jour automatiquement lorsque l'avancement d'une inspection change (réception de la vidéo, traitement, rapport disponible).",
      en: 'All the inspections of your scope, performed by a professional or by an individual. The list refreshes automatically when the progress of an inspection changes (video received, processing, report available).',
    },
    docSlug: 'liste-des-inspections',
  },
  requestsTable: {
    title: { fr: "Les demandes d'inspection", en: 'Inspection requests' },
    text: {
      fr: "Inspections demandées à des particuliers : une demande est créée pour un véhicule puis envoyée au particulier, qui réalise l'inspection avec le lien reçu. Vous pouvez aussi importer une liste de demandes. Une fois l'inspection réalisée, la demande suit les mêmes étapes que les autres inspections.",
      en: 'Inspections requested to individuals: a request is created for a vehicle then sent to the individual, who performs the inspection with the link received. You can also import a list of requests. Once the inspection is done, the request goes through the same steps as the other inspections.',
    },
    docSlug: 'demandes-d-inspection',
  },
  dateColumn: {
    title: { fr: 'Date', en: 'Date' },
    text: {
      fr: "Date et heure de la dernière mise à jour de l'inspection. Cliquez sur l'en-tête pour trier la liste par date.",
      en: 'Date and time of the last update of the inspection. Click the header to sort the list by date.',
    },
    docSlug: 'liste-des-inspections',
  },
  typeColumn: {
    title: { fr: "Type d'inspection", en: 'Inspection type' },
    text: {
      fr: "« Pro » : inspection réalisée par un utilisateur professionnel de la structure. « Part. » : inspection réalisée par un particulier, à partir d'une demande d'inspection.",
      en: '"Pro": inspection performed by a professional user of the structure. "Indiv.": inspection performed by an individual, from an inspection request.',
    },
    docSlug: 'demandes-d-inspection',
  },
  clientColumn: {
    title: { fr: 'Client', en: 'Client' },
    text: {
      fr: "Personne ayant réalisé l'inspection, avec le groupe, la société et l'exploitation auxquels elle est rattachée (selon votre périmètre).",
      en: 'Person who performed the inspection, with the group, company and branch they are linked to (depending on your scope).',
    },
    docSlug: 'liste-des-inspections',
  },
  statusColumn: {
    title: { fr: 'Statut du rapport', en: 'Report status' },
    text: {
      fr: "Affiché quand le rapport est disponible. Modération : « À modérer » tant que l'équipe de modération n'a pas contrôlé et corrigé les résultats de l'IA, puis « Modérée ». Validation (une fois modérée) : « À valider » tant que le client n'a pas validé sa version du rapport, puis « Validée » ; un rapport validé n'est plus modifiable. Avant cela, la colonne indique ce qui est attendu : inspection, vidéo ou rapport.",
      en: 'Displayed when the report is available. Moderation: "To moderate" until the moderation team has checked and corrected the AI results, then "Moderated". Validation (once moderated): "To validate" until the client has validated their version of the report, then "Validated"; a validated report can no longer be edited. Before that, the column shows what is awaited: inspection, video or report.',
    },
    docSlug: 'statuts-d-inspection',
  },
  progressColumn: {
    title: { fr: 'Réalisation', en: 'Progress' },
    text: {
      fr: "Avancement de l'inspection : « Demande créée » puis « Demande créée et envoyée » pour les demandes, « Inspection en cours », puis « Inspection réalisée » avec une étape détaillée : en cours de réception (la vidéo est en train d'être envoyée), en cours de traitement (analyse par l'IA), puis rapport disponible.",
      en: 'Progress of the inspection: "Request created" then "Request created and sent" for requests, "Inspection in progress", then "Inspection completed" with a detailed step: receipt in progress (the video is being uploaded), process in progress (AI analysis), then report available.',
    },
    docSlug: 'statuts-d-inspection',
  },
  usageTable: {
    title: { fr: 'Volume des inspections', en: 'Inspection usage' },
    text: {
      fr: "Suivi de la consommation : chaque ligne est une inspection. Filtrez par période, structure, type (pro / particulier) ou client ; le nombre affiché à côté du titre de la page donne alors le nombre d'inspections correspondant, pratique pour suivre la consommation d'un client sur une période.",
      en: 'Usage follow-up: each row is an inspection. Filter by period, structure, type (pro / individual) or client; the number next to the page title then gives the matching number of inspections: handy to follow the usage of a client over a period.',
    },
    docSlug: 'consommation-des-inspections',
  },
  emailsTable: {
    title: { fr: 'Emails envoyés', en: 'Sent emails' },
    text: {
      fr: "Emails envoyés pour cette demande d'inspection. « Consulter » affiche le détail de l'email : expéditeur, destinataires, objet et contenu.",
      en: 'Emails sent for this inspection request. "View" displays the details of the email: sender, recipients, subject and content.',
    },
    docSlug: 'emails-d-inspection',
  },
} satisfies Record<string, HelpTip>;
